import { Link } from "react-router-dom";

export const Btn = ({ to, href, onClick, children, variant = "red", className = "", testid, type, disabled }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 min-h-[48px]";
  const styles = {
    red: "bg-[#E63946] text-white hover:bg-[#BA1B25] hover:scale-[1.04] shadow-[0_8px_30px_rgba(230,57,70,0.25)]",
    dark: "bg-[#0A0A0A] text-white hover:bg-[#1A1A1A] hover:scale-[1.04]",
    outline: "border border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white",
    ghostLight: "border border-white/40 text-white hover:bg-white hover:text-[#0A0A0A]",
  };
  const cls = `${base} ${styles[variant]} ${disabled ? "opacity-50 pointer-events-none" : ""} ${className}`;
  if (to) return <Link to={to} className={cls} data-testid={testid}>{children}</Link>;
  if (href) return <a href={href} className={cls} data-testid={testid} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">{children}</a>;
  return <button type={type || "button"} onClick={onClick} className={cls} data-testid={testid} disabled={disabled}>{children}</button>;
};

export const Eyebrow = ({ children, dark }) => (
  <div className={`flex items-center gap-3 mb-6 ${dark ? "text-white/60" : "text-[#0A0A0A]/50"}`}>
    <span className="h-px w-10 bg-[#E63946]" />
    <span className="text-xs uppercase tracking-[0.25em] font-medium">{children}</span>
  </div>
);

export const Field = ({ label, name, type = "text", required, textarea, value, onChange, options, ...rest }) => (
  <label className="block">
    <span className="block text-xs uppercase tracking-[0.18em] text-[#0A0A0A]/60 mb-2">{label}{required && " *"}</span>
    {options ? (
      <select name={name} required={required} value={value} onChange={onChange} data-testid={`field-${name}`}
        className="w-full border-b-2 border-[#0A0A0A]/20 bg-transparent py-3 text-base focus:border-[#E63946] outline-none transition-colors">
        <option value="">Select…</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    ) : textarea ? (
      <textarea name={name} required={required} value={value} onChange={onChange} rows={4} data-testid={`field-${name}`}
        className="w-full border-b-2 border-[#0A0A0A]/20 bg-transparent py-3 text-base focus:border-[#E63946] outline-none transition-colors resize-none" {...rest} />
    ) : (
      <input name={name} type={type} required={required} value={value} onChange={onChange} data-testid={`field-${name}`}
        className="w-full border-b-2 border-[#0A0A0A]/20 bg-transparent py-3 text-base focus:border-[#E63946] outline-none transition-colors" {...rest} />
    )}
  </label>
);
